<subscription-page
  [subscription]="subscription()"
  [reportedStatus]="reportedStatus()"
  [isLoading]="isLoading()"
  [isNotFound]="isNotFound()"
  [isNotAuthorized]="isNotAuthorized()"
>
  @if (subscription(); as sub) {
    <l2vpn-subscription-view
      [subscription]="sub"
      [activities]="activities()"
      [activeTab]="activeTab()"
      (tabChange)="changeActiveTab($event)"
      (selfServiceOpen)="openSelfServiceDialog($event)"
    />
  }
</subscription-page>
